import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { NewsService } from '../news.service';
import { News } from '../news';
import { Location } from '@angular/common';
import { NgForm } from '@angular/forms';
import { Message } from 'primeng/primeng';

@Component({
  selector: 'app-news-crud',
  templateUrl: './news-crud.component.html',
  styleUrls: ['./news-crud.component.css'],
  providers: [ NewsService ]
})
export class NewsCrudComponent implements OnInit {

  id: any = null;
	msgs: Message[] = [];
  loading: boolean = false;
  news:News;


 	button_caption: string ="Сохранить"
 	button_icon:string ="fa fa-save";

  constructor(
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private location: Location,
              private newsService: NewsService
             ) { 
              activatedRoute.params.subscribe(params=>{this.id=params['id']});
              
              if(this.id){
                this.loading = true;
                this.newsService.getNewsById(this.id).subscribe(response=>{this.news = response['data'];this.loading = false;})
              }

             }



  ngOnInit() {

    this.news={
      title:"",
      description:"",
      tags:"",
      available:true
    }

  }

  backClicked() {
    this.location.back();
  }

  crud(form):void{
    console.log(form.value);
    if(!this.id){
       this.loading=true;  
        this.newsService.createNews(form.value)
        .subscribe((data) => {this.loading=false;this.router.navigate(['/dashboard/news']);}
             , (error)=>{
                   let str="";
                     this.loading=false; 
                     for (let item in error.error.errors) {
                           str+="\n" +error.error.errors[item][0];
                     }
                     this.msgs.push({severity:'error', summary:'Сообщение', detail: "Ошибка: "+str});
             });

    }else{
     this.loading=true;  
      this.newsService.updateNews(form.value,this.id)
        .subscribe((data) => {this.loading=false;this.router.navigate(['/dashboard/news']);}
             , (error)=>{
                let str="";
                     this.loading=false; 
                     for (let item in error.error.errors) {
                           str+="\n" +error.error.errors[item][0];
                     }
                     this.msgs.push({severity:'error', summary:'Сообщение', detail: "Ошибка: "+str});
             });
    }



}	 
}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/news/news-crud/news-crud.component.ts